import includes from "lodash/includes";
import { createMemoryHistory } from "history";
import { useRouterHistory } from "react-router";

import { PostMessage } from "../../constants/chat";
import { postMessageToParent } from "../Utils";
import storage from "./ChatStorage";
import Analytics from "./Analytics";
import { triggerNavigateEvent } from "./EventHelper";

const DEFAULT_PATH = "/minimized";

export const history = useRouterHistory(createMemoryHistory)({ basename: "/chat" });

export class ChatNavigation {
    constructor() {
        this.history = history;
        this.location = {};

        return this;
    }

    onLocationChange(location) {
        this.location = location;
        storage.setItem("path", `${location.pathname}${location.search}${location.hash}`);
        triggerNavigateEvent(location);
        Analytics.pageview(location.pathname.replace(/\/\d+$/, ""));
        this.syncIframeStateWithLocation();
    }

    get isUserActive() {
        return !includes(this.location.pathname, "/minimized");
    }

    get isMinimizedView() {
        return includes(this.location.pathname, "/minimized");
    }

    get isAskQuestionView() {
        return includes(this.location.pathname, "/ask");
    }

    syncIframeStateWithLocation() {
        if (this.isMinimizedView) {
            postMessageToParent(PostMessage.MINIMIZE);
        } else if (this.isAskQuestionView) {
            postMessageToParent(PostMessage.MAXIMIZE_ASK_QUESTION);
        } else {
            postMessageToParent(PostMessage.MAXIMIZE);
        }
    }

    init() {
        this.history.unlisten = this.history.listen(this.onLocationChange.bind(this));
        this.history.replace(storage.getItem("path") || DEFAULT_PATH);
    }
}

export default new ChatNavigation();
